import { usePostProfileMenuPositionMutation } from '../../../api'
import { TMenuLayout } from '../../../../shared/consts/MenuLayout.const'
import { useAppSelector } from '../../../store/hooks/Redux'
import { selectMenuLayout } from '../../../store/reducers/AppSlice'

export const useMenuLayout = () => {
  const menuLayout = useAppSelector(selectMenuLayout)

  const [editMenuPosition, { isLoading }] = usePostProfileMenuPositionMutation()

  // Меню переключится, когда придёт ответ: значение в сторе ставит сама мутация
  const switchMenuLayout = (layout: TMenuLayout) => {
    editMenuPosition({ body: { front_menu_position: layout } })
  }

  return { menuLayout, switchMenuLayout, isSwitching: isLoading }
}
